import { DomainIDs } from 'common/constants/enums';

import { GlobalState } from '../store/initialState';

export const getTotalMounted = (state: GlobalState): number =>
  state[DomainIDs.CONTENT_MODAL].totalMounted;
